import React from "react";
import CommonGridSection from "../../component/common/CommonGridSection";

const benefitsData = [
  {
    title: "Long-Term Soil Fertility",
    desc: "Enhances soil quality over time without degrading its natural properties.",
    icon: "/images/plantIcon1.png",
  },
  {
    title: "Eco-Friendly and Sustainable",
    desc: "Supports organic farming practices and reduces environmental impact.",
    icon: "/images/plantIcon1.png",
  },
  {
    title: "Safe for Crops and Consumers",
    desc: "Free from harmful chemicals, making it safe for plants and human consumption.",
    icon: "/images/plantIcon1.png",
  },
  {
    title: "Cost-Effective Solution",
    desc: "Reduces dependency on synthetic inputs and enhances farm productivity.",
    icon: "/images/plantIcon1.png",
  },
];

const BenefitsSection = () => {
  return (
    <CommonGridSection
      subHeader="Our Benefits"
      mainHeader="Benefits of Using Our Organic Fertilizers"
      items={benefitsData}
      backgroundColor="bg-[#1C233A]" // Dark Blue
      cardColor="bg-[#B7DB83]" // Light Green
      textColor="text-white"
    />
  );
};

export default BenefitsSection;
